import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { User, Calendar, Tag, Eye, Bookmark, Check, ArrowRight } from "lucide-react";
import ReactionBar from "./ReactionBar";
import CommentSection from "./CommentSection";
import ShareButtons from "./ShareButtons";
import "./Blog.css";

const BlogDetail = () => {

  // const { id } = useParams(); // change param to 'id'

  const { slug } = useParams();
const url=process.env.REACT_APP_LINK
  const [blog, setBlog] = useState(null);
  const [isSaved, setIsSaved] = useState(false);
  const userId = 1; // Replace with actual logged-in user ID if available
  const [scrollProgress, setScrollProgress] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);


  useEffect(() => {
    if (!slug) return;

    setLoading(true);
    setError(false);

    fetch(`${url}/api/blogs/slug/${slug}`)
      .then((res) => {
        if (!res.ok) throw new Error("Blog not found");
        return res.json();
      })
      .then((data) => {
        let desc = data.description;

        try {
          if (typeof desc === "string") {
            const parsed = JSON.parse(desc);
            desc = Array.isArray(parsed) ? parsed : [parsed];
          } else if (!Array.isArray(desc)) {
            desc = [desc];
          }
        } catch (err) {
          console.error("❌ Description JSON parse error:", err);
          desc = [desc];
        }

        desc = desc.filter((d) => typeof d === "string" && d.trim() !== "");
        setBlog({ ...data, description: desc });
        setLoading(false);
      })
      .catch((err) => {
        console.error("❌ Failed to fetch blog:", err);
        setError(true);
        setLoading(false);
      });
  }, [slug]);


  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (scrollTop / docHeight) * 100;
      setScrollProgress(scrolled);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const checkSaved = async () => {
      try {
        const res = await fetch(`${url}/api/save/${userId}`);
        const data = await res.json();
        const found = data.find((item) => item.blogId === blog?._id);
        setIsSaved(!!found);
      } catch (err) {
        console.error("❌ Save check failed:", err);
      }
    };

    if (blog?._id) checkSaved();
  }, [blog?._id]);

  //   const handleSave = async () => {
  //     try {
  //       const res = await fetch("${url}/api/save", {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  // body: JSON.stringify({ userId, blogId: blog?._id }),
  //       });

  //       if (res.ok) {
  //         setIsSaved(true);
  //         alert("📌 Saved for later!");
  //       } else {
  //         alert("⚠️ Already saved or failed.");
  //       }
  //     } catch (err) {
  //       console.error("❌ Save failed:", err);
  //     }
  //   };

  if (blog === null) return <p className="blog-detail-hbt-loading">Loading blog...</p>;
  if (blog === false) return <p className="blog-detail-hbt-error">Blog not found.</p>;

  const formattedDate = new Date(blog.publishedAt || blog.createdAt).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <>
      {/* Smooth Scroll Progress Bar */}
      <div
        className="blog-scroll-progress-bar"
        style={{
          position: "fixed",
          top: "64px",
          left: 0,
          height: "4px",
          background: "linear-gradient(to right, #E3BC82, #101010)",
          width: `${scrollProgress}%`,
          zIndex: 9999,
          transition: "width 0.2s ease-out",
        }}
      />

      <div className="blog-detail-container">
        {/* Featured Tag */}
        {blog.isFeatured && (
          <div className="featured-badge">
            <span>🔥 Featured</span>
          </div>
        )}

        {/* Title */}
        <h1 className="blog-title">{blog.title}</h1>

        {/* Meta Info */}
        <div className="blog-meta">
          <span><User size={16} /> {blog.authorName || "Unknown Author"}</span>
          <span><Calendar size={16} /> {formattedDate}</span>
          <span><Tag size={16} /> {blog.category || "Uncategorized"}</span>
          <span><Eye size={16} /> {blog.views || 0} views</span>
        </div>

        {/* Banner Image */}
        {blog.image1 && (
          <div className="blog-image-wrapper">
            <img
              src={`${url}/${blog.image1}`}
              alt="Blog Visual"
              className="blog-image"
            />
          </div>
        )}

        {/* CTA */}
        {blog.actionType && blog.actionValue && (
          <div className="blog-cta-wrapper">
            <a
              href={blog.actionType === "call" ? `tel:${blog.actionValue}` : blog.actionValue}
              target={blog.actionType === "link" ? "_blank" : "_self"}
              rel="noopener noreferrer"
              className="blog-cta-button"
            >
              <ArrowRight size={18} /> Get Started Now
            </a>
          </div>
        )}

        {/* Blog Description */}
        <div className="blog-description">
          {Array.isArray(blog.description)
            ? blog.description.map((para, idx) => <p key={idx}>{para}</p>)
            : <p>{blog.description}</p>}
        </div>

        {/* Optional Image */}
        {blog.image2 && (
          <div className="blog-image-wrapper">
            <img
              src={`${url}/${blog.image2}`}
              alt="Additional Visual"
              className="blog-image-secondary"
            />
          </div>
        )}

        {/* Reactions & Comments */}
        <ReactionBar blogId={blog?.slug} />
        <CommentSection slug={blog.slug} />

        {/* Share Buttons */}
        <ShareButtons blogUrl={window.location.href} blogTitle={blog.title} />
      </div>
    </>
  );
};

export default BlogDetail;
